import { render } from "./AuthAppPromo.vue?vue&type=template&id=b80a4334"
import script from "./AuthAppPromo.vue?vue&type=script&lang=js"
export * from "./AuthAppPromo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__